import DrawerButton from '../Button/DrawerButton';
import SmartLink from '../Button/SmartLink';
import Family from '@/images/hero/family3.png';
import Financing from '@/images/hero/california-home-2.jpg';
import Image from 'next/legacy/image';

export default function AlternatingHighlights() {
  return (
    <div className="relative pt-16 pb-32 overflow-hidden bg-white">
      <div className="relative">
        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div className="max-w-xl px-4 mx-auto sm:px-6 lg:py-8 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              {/* <div>
                <span className="flex items-center justify-center w-12 h-12 rounded-md bg-primary-600">
                  <InboxIcon
                    className="w-6 h-6 text-white"
                    aria-hidden="true"
                  />
                </span>
              </div> */}
              <div className="mt-6">
                <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                  Savings you can count on
                </h2>
                <p className="mt-4 text-lg text-gray-500">
                  With EnergyPal packages, you get more than just a solar system
                  &amp; batteries and lower utility bills. You get the
                  satisfaction from knowing we provide you with premium
                  products, installation services and warranties, at incredible
                  value versus the competition. With EnergyPal, you get more and
                  save more!
                </p>
                <div className="mt-6">
                  <SmartLink
                    href="/best-solar-company-reviews"
                    className="font-bold text-primary hover:text-primary-700 hover:underline"
                  >
                    Learn More &rarr;
                  </SmartLink>
                  {/* <DrawerButton /> */}
                  {/* <a
                    href="#"
                    className="inline-flex px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-primary-600 hover:bg-primary-700"
                  >
                    Get started
                  </a> */}
                </div>
              </div>
            </div>
            {/* <div className="pt-6 mt-8 border-t border-gray-200">
              <blockquote>
                <div>
                  <p className="text-base text-gray-500">
                    &ldquo;Cras velit quis eros eget rhoncus lacus ultrices sed
                    diam. Sit orci risus aenean curabitur donec aliquet. Mi
                    venenatis in euismod ut.&rdquo;
                  </p>
                </div>
                <footer className="mt-3">
                  <div className="flex items-center space-x-3">
                    <div className="flex-shrink-0">
                      <img
                        className="w-6 h-6 rounded-full"
                        src="https://images.unsplash.com/photo-1509783236416-c9ad59bae472?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                        alt=""
                      />
                    </div>
                    <div className="text-base font-medium text-gray-700">
                      Marcia Hill, Digital Marketing Manager
                    </div>
                  </div>
                </footer>
              </blockquote>
            </div> */}
          </div>
          <div className="relative mt-12 sm:mt-16 lg:mt-0">
            <Image
              src={Family}
              alt="Value you can count on"
              layout="fill"
              objectFit="cover"
              className="shadow-xl rounded-xl ring-1 ring-black ring-opacity-5"
            />
            {/* <div className="relative pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0">
              <Image
                src={Family}
                alt="Value you can count on"
                className="absolute inset-0 shadow-xl rounded-xl ring-1 ring-black ring-opacity-5"
              />
            </div> */}
          </div>
        </div>
      </div>
      <div className="mt-24">
        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div className="max-w-xl px-4 mx-auto sm:px-6 lg:py-8 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
            <div>
              {/* <div>
                <span className="flex items-center justify-center w-12 h-12 rounded-md bg-primary-600">
                  <SparklesIcon
                    className="w-6 h-6 text-white"
                    aria-hidden="true"
                  />
                </span>
              </div> */}
              <div className="mt-6">
                <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                  Financing &amp; incentives
                </h2>
                <p className="mt-4 text-lg text-gray-500">
                  EnergyPal provides an unbiased perspective on solar leases,
                  solar loans, and cash purchases. We will help you design the
                  right-sized energy system, secure all available incentives,
                  and qualify your project for the best financing offers from
                  only the most trusted solar lending institutions. No one
                  offers more, putting your best interests first, than
                  EnergyPal.
                </p>
                <div className="mt-6">
                  <DrawerButton />
                  {/* <a
                    href="#"
                    className="inline-flex px-4 py-2 text-base font-medium text-white border border-transparent rounded-md shadow-sm bg-primary-600 hover:bg-primary-700"
                  >
                    Get started
                  </a> */}
                </div>
              </div>
            </div>
          </div>
          <div className="relative mt-12 sm:mt-16 lg:mt-0 lg:col-start-1">
            <Image
              src={Financing}
              alt="Financing &amp; incentives"
              layout="fill"
              objectFit="cover"
              objectPosition="left top"
              className="shadow-xl rounded-xl ring-1 ring-black ring-opacity-5"
            />
            {/* <div className="pr-4 -ml-48 sm:pr-6 md:-ml-16 lg:px-0 lg:m-0 ">
              <img
                className="w-full shadow-xl rounded-xl ring-1 ring-black ring-opacity-5 "
                src="https://tailwindui.com/img/component-images/inbox-app-screenshot-2.jpg"
                alt="Customer profile user interface"
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
